// extracted by mini-css-extract-plugin
export var grid = "_2w-0";
export var span1 = "_2w-2";
export var span10 = "_2w-b";
export var span10L = "_2w-z";
export var span10M = "_2w-n";
export var span10Xl = "_2w-1b";
export var span11 = "_2w-c";
export var span11L = "_2w-10";
export var span11M = "_2w-o";
export var span11Xl = "_2w-1c";
export var span12 = "_2w-d";
export var span12L = "_2w-11";
export var span12M = "_2w-p";
export var span12Xl = "_2w-1d";
export var span1L = "_2w-q";
export var span1M = "_2w-e";
export var span1Xl = "_2w-12";
export var span2 = "_2w-3";
export var span2L = "_2w-r";
export var span2M = "_2w-f";
export var span2Xl = "_2w-13";
export var span3 = "_2w-4";
export var span3L = "_2w-s";
export var span3M = "_2w-g";
export var span3Xl = "_2w-14";
export var span4 = "_2w-5";
export var span4L = "_2w-t";
export var span4M = "_2w-h";
export var span4Xl = "_2w-15";
export var span5 = "_2w-6";
export var span5L = "_2w-u";
export var span5M = "_2w-i";
export var span5Xl = "_2w-16";
export var span6 = "_2w-7";
export var span6L = "_2w-v";
export var span6M = "_2w-j";
export var span6Xl = "_2w-17";
export var span7 = "_2w-8";
export var span7L = "_2w-w";
export var span7M = "_2w-k";
export var span7Xl = "_2w-18";
export var span8 = "_2w-9";
export var span8L = "_2w-x";
export var span8M = "_2w-l";
export var span8Xl = "_2w-19";
export var span9 = "_2w-a";
export var span9L = "_2w-y";
export var span9M = "_2w-m";
export var span9Xl = "_2w-1a";
export var stretch = "_2w-1";